import { takeLatest, put, call } from 'redux-saga/effects';

import { listEmitenteCadastro } from '../service';
import {
  TABLE_EMITENTE_CADASTRO,
  TABLE_EMITENTE_CADASTRO_PENDING,
  TABLE_EMITENTE_CADASTRO_SUCCESS,
  TABLE_EMITENTE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListEmitenteCadastro(action) {
  yield put({ type: TABLE_EMITENTE_CADASTRO_PENDING })

  try {
    const table = yield call(listEmitenteCadastro, action.args)
    yield put({ type: TABLE_EMITENTE_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_EMITENTE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListEmitenteCadastro() {
  yield takeLatest(TABLE_EMITENTE_CADASTRO, sagaListEmitenteCadastro)
}